import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import poster from '@/static/assets/reviews/BobJacobsen_Pet/video.jpg';
import subs from '@/static/assets/reviews/BobJacobsen_Pet/subs.vtt';

export const BobJacobsen: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet, ReviewProduct.All],
  reviewerName: 'Bob',
  videoUrl: `${ASSETS_URL}/pet/BobJacobsen_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
